// @ts-nocheck
import { ReactNode } from 'react';
import SimpleForm, { SimpleFormItemProps } from '../../SimpleForm';
import { EditColumnType } from '../interface';

function getFormItem(record: any, props?: EditColumnType): ReactNode {
  if (!props) return null;
  const {
    formItemType,
    name,
    initialValue,
    required,
    rules,
    form,
    disabled,
    disabledRender,
    disabledRenderKey,
    optionsKey,
    enumCode,
    enumCodeKey,
    defaultPropsKey,
    inputProps,
    inputNumberProps,
    switchProps,
    checkboxProps,
    checkboxGroupProps,
    datePickerProps,
    rangePickerProps,
    timePickerProps,
    selectProps,
    selectTableProps,
    superAutoCompleteProps,
  } = props;
  const baseSearchFormProps: SimpleFormItemProps = {
    name,
    initialValue,
    rules,
    form,
  };
  if (disabledRenderKey && !disabledRender) {
    baseSearchFormProps.disabledRender = record[disabledRenderKey];
  }
  if (required && !rules) {
    baseSearchFormProps.rules = [
      {
        required,
      },
    ];
  }
  let baseFormProps = { disabled };
  if (defaultPropsKey && record[defaultPropsKey]) {
    baseFormProps = { ...record[defaultPropsKey], ...baseFormProps };
  }
  let currentEnumCode = enumCode;
  if (enumCodeKey) currentEnumCode = record[enumCodeKey];
  switch (formItemType) {
    case 'Input':
      return (
        <SimpleForm.Input
          {...baseSearchFormProps}
          inputProps={{ ...baseFormProps, ...inputProps }}
        />
      );
    case 'InputNumber':
      return (
        <SimpleForm.InputNumber
          {...baseSearchFormProps}
          inputNumberProps={{ ...baseFormProps, ...inputNumberProps }}
        />
      );
    case 'SuperAutoComplete':
      return (
        <SimpleForm.SuperAutoComplete
          {...baseSearchFormProps}
          superAutoCompleteProps={{ ...baseFormProps, ...superAutoCompleteProps }}
        />
      );
    case 'Switch':
      return (
        <SimpleForm.Switch
          {...baseSearchFormProps}
          switchProps={{ ...baseFormProps, ...switchProps }}
        />
      );
    case 'Checkbox':
      return (
        <SimpleForm.Checkbox
          {...baseSearchFormProps}
          checkboxProps={{ ...baseFormProps, ...checkboxProps }}
        />
      );
    case 'CheckboxGroup':
      return (
        <SimpleForm.CheckboxGroup
          {...baseSearchFormProps}
          enumCode={currentEnumCode}
          checkboxGroupProps={{ ...baseFormProps, ...checkboxGroupProps }}
        />
      );
    case 'DatePicker':
      return (
        <SimpleForm.DatePicker
          {...baseSearchFormProps}
          datePickerProps={{ ...baseFormProps, ...datePickerProps }}
        />
      );
    case 'RangePicker':
      return (
        <SimpleForm.RangePicker
          {...baseSearchFormProps}
          rangePickerProps={{ ...baseFormProps, ...rangePickerProps }}
        />
      );
    case 'TimePicker':
      return (
        <SimpleForm.TimePicker
          {...baseSearchFormProps}
          timePickerProps={{ ...baseFormProps, ...timePickerProps }}
        />
      );
    case 'Select':
      const options = record[optionsKey || 'options'];
      return (
        <SimpleForm.Select
          {...baseSearchFormProps}
          enumCode={currentEnumCode}
          selectProps={{ options, ...baseFormProps, ...selectProps }}
        />
      );
    case 'SelectTable':
      if (!selectTableProps) return null;
      let initOptions: any[] = [];
      let namekey = props?.namekey;
      let valuekey = props?.valuekey;
      let label = selectTableProps?.nameKey;
      let value = selectTableProps?.valueKey;
      if (namekey && valuekey && value && label) {
        const labels = record[namekey];
        const values = record[valuekey];
        if (Array.isArray(values)) {
          values.forEach((v, k) => {
            initOptions.push({
              [label as string]: labels[k],
              [value as string]: v,
            });
          });
        } else {
          initOptions.push({
            [label]: record[namekey],
            [value]: record[valuekey],
          });
        }
      }
      return (
        <SimpleForm.SelectTable
          {...baseSearchFormProps}
          selectTableProps={{
            initOptions,
            ...baseFormProps,
            ...selectTableProps,
          }}
        />
      );
    default:
      return (
        <SimpleForm.Input
          {...baseSearchFormProps}
          inputProps={{ ...baseFormProps, ...inputProps }}
        />
      );
  }
}

export default getFormItem;
